(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.alwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.onScrollHandler = this.onScroll.bind(this);

      if (this.alwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.header.classList.toggle('scrolled-past-header', scrollTop > 20);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
